import { useApiWithAuth } from '@/hooks/api';
import { useTagsStore } from '.';
import { useCallback, useEffect, useRef, useState } from 'react';
import { loadTags } from './actions';

export function useTags() {
  const { api, auth } = useApiWithAuth();
  const store = useTagsStore();
  const [loading, setLoading] = useState(false);
  const loaded = useRef(false);

  const fetchTags = useCallback(async () => {
    if (loaded.current || loading) {
      return;
    }

    setLoading(true);
    loaded.current = true;

    try {
      await loadTags(store, { force: false, api, auth });
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [api, auth, loading, store]);

  useEffect(() => {
    fetchTags();
  }, [fetchTags]);

  return {
    loading,
    list: store.state.list,
    lookup: store.state.lookup,
  };
}
